import React from 'react'
import {CodeMasterInterface} from '../../../../CodeMaster'
import withStyles from '@mui/styles/withStyles';
import styled from 'styled-components'
import {Colors, FontFamily} from '../../../../styledComponents/Constants'


import { Tabs, Tab } from '@mui/material';


interface Props {
    onChangeStatus: (selectedCategoryList: CodeMasterInterface[]) => void
    statusList: CodeMasterInterface[]
    selectedStatusList: CodeMasterInterface[]
    displayAllButton?: boolean
}

export const StatusSelector: React.FC<Props> = props => {
    const {statusList, displayAllButton, selectedStatusList} = props

    const handleChange = (event: React.ChangeEvent<{}>, value: number) => {
        let newSelectedCategoryList: CodeMasterInterface[] = [...selectedStatusList]

        if (displayAllButton) {
            if (value === 0) {
                props.onChangeStatus([])
                return
            }
            value -= 1
        }
        const indexOfSelectedCategory = selectedStatusList.indexOf(statusList[value])
        if (indexOfSelectedCategory !== -1) {
            newSelectedCategoryList = selectedStatusList
                .filter(category => category !== statusList[value])
        } else {
            newSelectedCategoryList.push(statusList[value])
        }

        props.onChangeStatus(newSelectedCategoryList)
    }

    if (statusList.length <= 1) {
        return null
    }
    return <SelectorArea>
        <Selectors
            variant="standard"
            scrollButtons={false}
            value={false}
            onChange={handleChange}
        >
            {
                displayAllButton &&
                <Selector
                    label="すべて"
                    isSelected={selectedStatusList.length === 0}
                />
            }
            {
                statusList.map((category, index) => (
                    <Selector
                        key={index}
                        label={category.label}
                        isSelected={selectedStatusList.includes(category)}
                    />
                ))
            }
        </Selectors>
    </SelectorArea>
}

const SelectorArea = styled.div`
  background-color: ${Colors.Surface};
`

const Selectors = withStyles({
    root: {
        minHeight: 0,
        marginRight: 0,
        marginLeft: 0,
        alignItems: 'center',
    },
    indicator: {
        display: 'none',
    },
    flexContainer: {
        flexWrap: 'wrap',
    },
})
(Tabs)

const Selector = styled(Tab)<{ isSelected: boolean }>`
  &.MuiTab-root {
    background-color: ${Colors.Surface};
    border-radius: 15px;
    border: solid 1px ${props => props.isSelected ? '#3F51B5' : Colors.AccentLight};
    color: ${props => props.isSelected ? '#3F51B5' : Colors.Body};
    min-width: auto;
    min-height: auto;
    height: 30px;
    margin-right: 16px;
    margin-bottom: 12px;
    line-height: 1.5;
    padding: 3px 10px;
    opacity: 1;
    font-size: 14px;
    font-family: ${FontFamily.ResidentDefault};
  }
`
